// Extracted from _loadingHelpers/EvTask.ts: a VALUE defined inside an aggregator
// that also imports its consumers is TDZ-read at module-eval time (hoisted
// prototype defaults in EvTaskRegistrationForm) — own module ends the cycle read.
enum ApplicatonMode {
    "apply" = 1,
    "remove" = -1
}

export default ApplicatonMode;
